import React,{Component} from 'react';
import { Modal,Row,Col ,Container} from 'react-bootstrap';
import {Button,FormSelect} from "shards-react";
import TimePicker from './TimePicker';

import { AtomSpinner } from 'react-epic-spinners';
import { toast } from 'react-toastify';
import firebase from '../firebase';

export default class AddTimeTable extends Component {

  constructor(props) {
    super(props);
  
    this.state = {
          subject:undefined,
          faculty:undefined,
          start_time:undefined,
          end_time:undefined,
          loading:false,
    };

    this.add_timetable = this.add_timetable.bind(this);
  }




  add_timetable = () =>{

    if(this.state.start_time===undefined || this.state.end_time===undefined){
        toast("Kindly Select Start time and end Time", {containerId: 'A'});
        return;
    }
    if(this.state.subject===undefined || this.state.faculty===undefined )
    {
          toast("Kindly Fill All Details", {containerId: 'A'});
          return;
    }

    var data = {
          day:this.props.get_selected_day(),
          class:this.props.get_selected_class(),
          subject:this.state.subject,
          faculty:this.state.faculty,
          start_time:this.state.start_time,
          end_time:this.state.end_time,
    }

    console.log(data)

    var that = this;
      
    var func_ref = firebase.functions().httpsCallable('AddTimeTable');  
                         
        this.setState({loading:true});      

        func_ref(data).then(function(result) {
                  // Read result of the Cloud Function.
                  var data = result.data;
                  console.log(data);
                  if(data.status==="success"){
                        console.log("Document succesfully added!");
                        toast('TimeTable  Added Successfully !', {containerId: 'A'});

                   }
                  else{
                        toast(data.error.message, {containerId: 'A'});
                        console.log(data.error.message);
                  }
                  that.setState({loading:false});

        }).catch(function(error) {
                  // Getting the Error details.
                  //var code = error.code;
                  //var message = error.message;
                  //var details = error.details;
                  // ...
                  console.log(error);
                  that.setState({loading:false});
                  toast("unable to add Student", {containerId: 'A'});
        });

      

  }





  render(){
  return (
    <Modal show={this.props.show} onHide={this.props.handleClose} size={"lg"}>
        <Modal.Header closeButton>
          <Modal.Title>{this.props.edit?"Edit":"Add"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            {
              !this.state.loading && 
              
              <Row className="show-grid">
                      <SubjectListInput subject_list={this.props.subject_list} 
                                        loading={this.props.loading} 
                                        onChange={(evt)=>{this.setState({subject:evt.target.value})}} />
                      
                      <TimeInp placeholder={"Start Time"} value={"12:00"} onChange={(evt)=>{this.setState({start_time:evt.target.value})}}/>
                      <TimeInp placeholder={"End Time"} value={"12:00"} onChange={(evt)=>{this.setState({end_time:evt.target.value})}} />
                      
                      <FacultyListInput faculty_list={this.props.faculty_list} 
                                        loading={this.props.loading} 
                                        onChange={(evt)=>{this.setState({faculty:evt.target.value})}} />
                
             </Row>
          }

            { 
              
                  (this.state.loading) &&
                    <div style={{margin: '10%',marginLeft: '40%'}}>
                        <AtomSpinner color="blue" />            
                    </div>
          

            }
          </Container>



        </Modal.Body>
        <Modal.Footer>
          <Button   theme="info" onClick={this.props.handleClose}>
            Close
          </Button>
          <Button theme="danger" onClick={this.add_timetable}>
            {"Add"}
           </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
    

class SubjectListInput extends Component{
  render(){
    return(
      <Col  md={3}>
        <label>Subject</label>
        <FormSelect onChange={this.props.onChange}>
                  <option>{this.props.loading?"Loading...":(this.props.subject_list.length>0?"Select Subject":"No Subjects Available")}</option>
                                          {

                                              this.props.subject_list.map((item,i)=>{
                                                             return (<option key={i}>{item.subjectname}</option>)
                                                })
                                           }
        </FormSelect>
        </Col>
      )
  }
}

class FacultyListInput extends Component{
  render(){
    return(
      <Col  md={3}>
        <label>Subject</label>
        <FormSelect onChange={this.props.onChange}>
                  <option>{this.props.loading?"Loading...":(this.props.faculty_list.length>0?"Select Faculty":"No Faculty Available")}</option>
                                          {

                                              this.props.faculty_list.map((item,i)=>{
                                                             return (<option key={i}>{item.fac_name}</option>)
                                               })
                                           }
        </FormSelect>
        </Col>
      )
  }
}

class TimeInp extends Component{
  render(){
    return(
      <Col  md={3}>
        <label>{this.props.placeholder}</label>
         <TimePicker placeholder={"Subject"} default={this.props.value} onChange={this.props.onChange}/>
        </Col>
      )
  }
}

